"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var escapeCss_1 = __importDefault(require("../../helperFunctions/escapeCss"));
var getSidebarColor = function (intensity) {
    return function (props) {
        return escapeCss_1.default(props.theme.sidebarColors["$" + String(intensity).padStart(3, "0")]);
    };
};
exports.default = getSidebarColor;
//# sourceMappingURL=index.js.map